import React from "react";

interface SensorReadingProps {
    value: string;
    code: number | null | undefined;
}

const SensorReading: React.FC<SensorReadingProps> = ({ value, code }) => {
    if (code == null) return <span style={{ color: '#aaa' }}>--</span>;
    if (code === 0) return <>{value}</>;
    const hex = `0x${code.toString(16).toUpperCase().padStart(2, '0')}`;
    return <span style={{ color: '#ff4d4f', fontSize: 13 }}>{hex}</span>;
};

export default SensorReading;
